module.exports = __webpack_public_path__ + "static/media/download-2.41497739.svg";